import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, Col, Row } from 'react-bootstrap';
import axiosInstance from '../../services/AxiosInstance';
import { hasInvoiceScannerSubscription } from '../../utils/invoiceScannerAccess';
import { canDo } from '../../utils/roleAccess';
import InternalFooter from '../components/InternalFooter/InternalFooter';
import '../tasks/tasklist.css';
import '../users/userlist.css';

export default function SnapBillSettings() {
  const navigate = useNavigate();
  const [message, setMessage] = useState('Opening Snap Bill settings…');
  const [denied, setDenied] = useState(false);

  useEffect(() => {
    let cancelled = false;

    async function openSettings() {
      try {
        if (!canDo('invoice_scanner_settings', 'create_edit')) {
          if (!cancelled) {
            setDenied(true);
            setMessage('Your role cannot change Snap Bill settings.');
          }
          return;
        }

        const hasAccess = await hasInvoiceScannerSubscription();
        if (!hasAccess) {
          if (!cancelled) {
            navigate('/subscription-feature-required?module=invoice_scanner', { replace: true });
          }
          return;
        }

        const res = await axiosInstance.get('/auth/module-handoff/invoice_scanner/redirect-url', {
          params: { destination: 'settings' },
        });
        const redirectUrl = res.data?.redirectUrl;
        if (!redirectUrl) {
          throw new Error('Missing redirect URL');
        }
        if (!cancelled) {
          window.location.replace(redirectUrl);
        }
      } catch (err) {
        console.error('Snap Bill settings redirect failed:', err);
        if (!cancelled) {
          setMessage(err.response?.data?.message || 'Unable to open Snap Bill settings. Please try again.');
        }
      }
    }

    openSettings();
    return () => {
      cancelled = true;
    };
  }, [navigate]);

  return (
    <>
      <Row style={{ marginBottom: '0px !important' }}>
        <Col lg={12}>
          <Card className="user-list-card">
            <Card.Body style={{ minHeight: '320px', padding: '1.5rem' }}>
              <div className="loading-container">
                {!denied && (
                  <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                )}
                <p className="text-muted mb-0 mt-3">{message}</p>
                {denied && (
                  <button
                    type="button"
                    className="btn btn-outline-secondary mt-3"
                    onClick={() => navigate('/settings')}
                  >
                    Back to settings
                  </button>
                )}
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
      <InternalFooter />
    </>
  );
}
